export default __webpack_public_path__ + "1868527ff93d84fd77c52da85c509312.woff2";